import { EnterFullScreenIcon } from '@/components/icons/enter-fullscreen';
import { useVideoStore } from '../hooks/use-video-store';
import { Button } from './button';
import { useIsMobileDevice } from '../hooks/use-is-mobile-device';

export function FullscreenButton() {
  const { toggleFullscreen } = useVideoStore((state) => ({
    toggleFullscreen: state.toggleFullscreen,
  }));

  const isMobileDevice = useIsMobileDevice();

  return (
    <Button
      label="Enter fullscreen"
      icon={<EnterFullScreenIcon />}
      onClick={() => toggleFullscreen(isMobileDevice)}
    />
  );
}
